import { render, staticRenderFns } from "./ButtonStyler.vue?vue&type=template&id=7418579f&"
import script from "./ButtonStyler.vue?vue&type=script&lang=js&"
export * from "./ButtonStyler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7418579f')) {
      api.createRecord('7418579f', component.options)
    } else {
      api.reload('7418579f', component.options)
    }
    module.hot.accept("./ButtonStyler.vue?vue&type=template&id=7418579f&", function () {
      api.rerender('7418579f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/helpers/ButtonStyler.vue"
export default component.exports